import { Controller } from '@hotwired/stimulus';

// The inbox list. Rows arrive live for every staff member, whatever list they
// have open, so each row is checked against this list's filter here, and the
// open thread keeps its highlight.
export default class extends Controller {
  static values = { filter: String, me: String, current: String };

  connect() {
    this.tidy();
    this.observer = new MutationObserver(() => this.tidy());
    this.observer.observe(this.element, { childList: true });
  }

  disconnect() {
    this.observer?.disconnect();
  }

  tidy() {
    this.element.querySelectorAll('[data-inbox-row]').forEach((row) => {
      const id = row.dataset.inboxRow;
      const current = id === this.currentValue;
      const fits =
        this.filterValue === 'all' ||
        (this.filterValue === 'needs' && row.dataset.waiting === 'true') ||
        (this.filterValue === 'mine' && row.dataset.assigned === this.meValue);
      row.hidden = !fits && !current;
      row.classList.toggle('bg-primary-100', current);
      if (current) row.setAttribute('aria-current', 'true');
    });
  }
}
